(function () {
  function openModal(handle) {
    const modal = document.querySelector('#stone-modal');
    const modalBody = modal?.querySelector('.stone-modal__body');
    const content = document.querySelector(`#stone-${handle}`);

    if (!modal || !modalBody || !content) return;

    modalBody.innerHTML = content.innerHTML;
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = document.querySelector('#stone-modal');
    if (!modal) return;

    modal.setAttribute('hidden', 'hidden');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.stone-card__button');
    if (btn) {
      openModal(btn.dataset.stoneHandle);
      return;
    }

    if (
      event.target.closest('.stone-modal__close') ||
      event.target.classList.contains('stone-modal__backdrop')
    ) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });
})();
